export const withTimeout: (time: number, f: typeof fetch) => typeof fetch =
  (time, f) => (req, opts) => {
    const abortController = new AbortController();
    setTimeout(() => {
      abortController.abort();
    }, time);
    return f(req, {
      ...opts,
      signal: abortController.signal,
    });
  };

// the `catch` on a `Promise` inherently takes a function that takes `any`
export function onAbort<R1, R2>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: (e: any) => R2 | Promise<R2>,
  p: Promise<R1>,
): Promise<R1 | R2> {
  return p.catch((e) => {
    if (e.name === 'AbortError') {
      return handler(e);
    }
    throw e;
  });
}
